import { useEffect, useState } from 'react';
import { getCompanies } from '../api/Company';
import { DataTable } from '../components/DataTable';
import { actionButtons } from '../components/ActionButtons';
import { ICompany } from '../util/DataModelInterface';
import { Spinner } from './Spinner';
import useToastHandler from '../hooks/useToastHandler';
import { Typeahead } from 'react-bootstrap-typeahead';
import { useIntl } from 'react-intl';

interface IReportAdminCompaniesTableData {
    // cols: 'company'
    company: string | undefined,
    actions: JSX.Element,
  }

export const ReportAdminCompanies = () => {

    const intl = useIntl();

    const [loading, setLoading] = useState(false);
    const [companies, setCompanies] = useState([] as ICompany[]);
    const { addToast } = useToastHandler();

    const [reportTableData, setReportTableData] = useState([] as IReportAdminCompaniesTableData[]);
    const [selections, setSelections] = useState([] as ICompany[]);

    useEffect(() => {
      setLoading(true);
      getCompanies().then((data: any) => {
          if (data?.error) {
            addToast(data.error, 'companies', 'fetch');
          } else if (data) {
            setCompanies(data);
          }
      }).finally(() => {
        setLoading(false);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
      parseTableData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selections, companies]);

    const parseTableData = () => {
      let data = [] as IReportAdminCompaniesTableData[];
      // 'company'
      companies.forEach((c) => {
        let compName = c.name;
        if (selections.length > 0 && !selections.find((s) => s.name === compName)) {
          // console.log("%s not in selections", compName);
        } else {
          data.push({
            company: c.name,
            actions: actionButtons(c.id ? c.id : '', c.name ? c.name : '', '', '', "/reportsAdmin/reportAdminCompany", false),
          });
        }
      });
      setReportTableData(data);
    }

    const foundItem = (sel: ICompany[]) => {
      let selItem = sel[0];
      console.log("found", selItem);
      setSelections(sel);
    }

    const filterByFields = ['business_id', 'name'];

    return (
        <div id="tab-tabpane-companies" role="tabpanel" aria-labelledby="tab-tab-companies">
          <Spinner active={loading} />
          <div className="search-group me-md-auto">
            <Typeahead
              id="typeahead-search-comp"
              inputProps={{
                'aria-label': intl.formatMessage({id: 'companies.search.text'}),
              }}
              clearButton
              filterBy={filterByFields}
              labelKey="name"
              onChange={(sel) => {foundItem(sel as ICompany[]);}}
              options={companies}
              placeholder={intl.formatMessage({id: 'companies.search.text'})}
              renderMenuItemChildren={(option) => (
                <div>
                  {(option as ICompany).name}
                  <div>
                    <small>{(option as ICompany).business_id}</small>
                  </div>
                </div>
              )}
            />
          </div>
              { reportTableData && (reportTableData.length > 0) &&
                <DataTable tableheadings={['company','actions']}
                    tabledata={reportTableData} caption='Company reports'
                    tableType='reports' tableId='companieslist'
                    optSortableColumns={['company']}
                />
              }
          
        </div>
    );
};